import {Component, CUSTOM_ELEMENTS_SCHEMA, OnInit} from '@angular/core';
import {GlobalLoaderService} from '../../../services/global-loader.service';
import {ApiAgentService} from '../../../services/api-agent.service';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {EnvironmentService} from '../../../services/environment.service';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {MyBusiness} from '../../../models/my-business';
import {ApiSettings} from '../../../models/api-settings.model';
import {ActivatedRoute, RouterModule} from '@angular/router';
import {firstValueFrom} from 'rxjs';
import {Partner} from '../../../models/partner';
import {CommonModule} from '@angular/common';

declare var Snackbar: any;

@Component({
  selector: 'app-api-keys',
  templateUrl: './api-keys.component.html',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule, RouterModule],
  styleUrls: ['./api-keys.component.scss']
})
export class ApiKeysComponent implements OnInit {

  submitting;
  form: FormGroup;
  settlementWebhookForm: FormGroup;
  partnerActivationWebhookForm: FormGroup;
  paymentWebhookForm: FormGroup;
  myBusiness: MyBusiness;
  apiSettings: ApiSettings;
  includeShopify: boolean;
  downloadingShopify: boolean;
  lang: any;
  loading: any;
  hasSettlementWebhookService: boolean;
  myPartners: Partner[];

  isAccountant: boolean;
  isManager: boolean;
  isSales: boolean;
  isMerchant: boolean;

  checkPermission() {
    let perms = this.env.checkPermission(this.myBusiness.subAccountType, this.myBusiness.subAccountGovId);
    this.isAccountant = perms.isAccountant;
    this.isSales = perms.isSales;
    this.isManager = perms.isManager;
    this.isMerchant = perms.isMerchant;
  }

  constructor(private loader: GlobalLoaderService,
              private formBuilder: FormBuilder,
              private activatedRoute: ActivatedRoute,
              private translate: TranslateService,
              private env: EnvironmentService,
              private api: ApiAgentService) {
  }

  async ngOnInit() {
    this.downloadingShopify = false;

    this.form = this.formBuilder.group({
      shopifyShopDomain: [''],
      apiId: [null],
      apiKey: [null],
    });

    this.settlementWebhookForm = this.formBuilder.group({
      webhookUrl: ['', [Validators.required]],
      httpHeader1: [''],
      httpHeader1Value: [''],
      httpHeader2: [''],
      httpHeader2Value: [''],
      httpHeader3: [''],
      httpHeader3Value: [''],
      httpHeader4: [''],
      httpHeader4Value: [''],
      httpHeader5: [''],
      httpHeader5Value: [''],
      version: ['']
    });

    this.partnerActivationWebhookForm = this.formBuilder.group({
      webhookUrl: ['', [Validators.required]],
      httpHeader1: [''],
      httpHeader1Value: [''],
      httpHeader2: [''],
      httpHeader2Value: [''],
      httpHeader3: [''],
      httpHeader3Value: [''],
      httpHeader4: [''],
      httpHeader4Value: [''],
      httpHeader5: [''],
      httpHeader5Value: [''],
      version: ['']

    });

    this.paymentWebhookForm = this.formBuilder.group({
      webhookUrl: ['', [Validators.required]],
      httpHeader1: [''],
      httpHeader1Value: [''],
      httpHeader2: [''],
      httpHeader2Value: [''],
      httpHeader3: [''],
      httpHeader3Value: [''],
      httpHeader4: [''],
      httpHeader4Value: [''],
      httpHeader5: [''],
      httpHeader5Value: [''],
      version: ['']

    });

    this.loading = true;

    // get my business
    this.myBusiness = await this.api.getMyBusiness(false);


    // check for shopify
    console.log('my business', this.myBusiness);
    this.includeShopify = this.myBusiness.paylinkSubscription.includeShopify;

    // load partner
    if (this.myBusiness.subAccountGovId == null) {
      this.api.getMyPartners().then(value => {
        this.myPartners = value;

        if (this.myPartners && this.myPartners.length > 0) {
          this.api.getPartnerActivationWebhookData().then(webhook => {
            this.partnerActivationWebhookForm.patchValue({
              webhookUrl: webhook.webhookUrl,
              httpHeader1: webhook.httpHeader1,
              httpHeader1Value: webhook.httpHeader1Value,
              httpHeader2: webhook.httpHeader2,
              httpHeader2Value: webhook.httpHeader2Value,
              httpHeader3: webhook.httpHeader3,
              httpHeader3Value: webhook.httpHeader3Value,
              httpHeader4: webhook.httpHeader4,
              httpHeader4Value: webhook.httpHeader4Value,
              httpHeader5: webhook.httpHeader5,
              httpHeader5Value: webhook.httpHeader5Value,
              version: webhook.version
            });
          }).catch(err => {
            console.log(err);
          });
        }

      });
    }

    // get api settings
    this.checkPermission();

    if (this.isMerchant || this.isManager) {
      try {
        this.apiSettings = await this.api.getMyApiSettings();

        this.form.patchValue({
          apiId: this.apiSettings.apiId,
          apiKey: this.apiSettings.secretKey,
        });

        this.form.controls['apiId'].disable();
        this.form.controls['apiKey'].disable();

      } catch (ex) {
      }
    }

    // fill webhooks form data - starting by payment
    this.api.getPaymentWebhookData().then(webhook => {
      this.paymentWebhookForm.patchValue({
        webhookUrl: webhook.webhookUrl,
        httpHeader1: webhook.httpHeader1,
        httpHeader1Value: webhook.httpHeader1Value,
        httpHeader2: webhook.httpHeader2,
        httpHeader2Value: webhook.httpHeader2Value,
        httpHeader3: webhook.httpHeader3,
        httpHeader3Value: webhook.httpHeader3Value,
        httpHeader4: webhook.httpHeader4,
        httpHeader4Value: webhook.httpHeader4Value,
        httpHeader5: webhook.httpHeader5,
        httpHeader5Value: webhook.httpHeader5Value,
        version: webhook.version
      });
    }).catch(err => {
      console.log(err);
    });

    if (this.hasSettlementWebhookService && (this.isMerchant || this.isManager)) {
      this.api.getSettlementWebhookData().then(webhook => {
        this.settlementWebhookForm.patchValue({
          webhookUrl: webhook.webhookUrl,
          httpHeader1: webhook.httpHeader1,
          httpHeader1Value: webhook.httpHeader1Value,
          httpHeader2: webhook.httpHeader2,
          httpHeader2Value: webhook.httpHeader2Value,
          httpHeader3: webhook.httpHeader3,
          httpHeader3Value: webhook.httpHeader3Value,
          httpHeader4: webhook.httpHeader4,
          httpHeader4Value: webhook.httpHeader4Value,
          httpHeader5: webhook.httpHeader5,
          httpHeader5Value: webhook.httpHeader5Value,
          version: webhook.version
        });
      }).catch(err => {
        console.log(err);
      });
    }

    setTimeout(async () => {
      await this.loadResources();
      this.loading = false;
      this.lang = await firstValueFrom(this.translate.get('lang'));

    }, 1000);
  }

  async submitForm() {
    this.submitting = true;

    try {
      if (this.hasSettlementWebhookService) {
        console.log('post settlement webhook',);
        await this.api.postSettlementWebhookData(
          this.settlementWebhookForm.value['webhookUrl'],
          this.settlementWebhookForm.value['httpHeader1'],
          this.settlementWebhookForm.value['httpHeader2'],
          this.settlementWebhookForm.value['httpHeader3'],
          this.settlementWebhookForm.value['httpHeader4'],
          this.settlementWebhookForm.value['httpHeader5'],
          this.settlementWebhookForm.value['httpHeader1Value'],
          this.settlementWebhookForm.value['httpHeader2Value'],
          this.settlementWebhookForm.value['httpHeader3Value'],
          this.settlementWebhookForm.value['httpHeader4Value'],
          this.settlementWebhookForm.value['httpHeader5Value'],
          this.settlementWebhookForm.value['version']
        );
      }

      // if partner
      if (this.myPartners && this.myPartners.length > 0 && this.myBusiness.licenseType != 'marketer' && !this.isAccountant && !this.isSales) {
        // post payment webhook
        await this.api.postPartnerActivationWebhookData(
          this.partnerActivationWebhookForm.value['webhookUrl'],
          this.partnerActivationWebhookForm.value['httpHeader1'],
          this.partnerActivationWebhookForm.value['httpHeader2'],
          this.partnerActivationWebhookForm.value['httpHeader3'],
          this.partnerActivationWebhookForm.value['httpHeader4'],
          this.partnerActivationWebhookForm.value['httpHeader5'],
          this.partnerActivationWebhookForm.value['httpHeader1Value'],
          this.partnerActivationWebhookForm.value['httpHeader2Value'],
          this.partnerActivationWebhookForm.value['httpHeader3Value'],
          this.partnerActivationWebhookForm.value['httpHeader4Value'],
          this.partnerActivationWebhookForm.value['httpHeader5Value'],
          this.partnerActivationWebhookForm.value['version']
        );
      }

      // post payment webhook
      await this.api.postPaymentWebhookData(
        this.paymentWebhookForm.value['webhookUrl'],
        this.paymentWebhookForm.value['httpHeader1'],
        this.paymentWebhookForm.value['httpHeader2'],
        this.paymentWebhookForm.value['httpHeader3'],
        this.paymentWebhookForm.value['httpHeader4'],
        this.paymentWebhookForm.value['httpHeader5'],
        this.paymentWebhookForm.value['httpHeader1Value'],
        this.paymentWebhookForm.value['httpHeader2Value'],
        this.paymentWebhookForm.value['httpHeader3Value'],
        this.paymentWebhookForm.value['httpHeader4Value'],
        this.paymentWebhookForm.value['httpHeader5Value'],
        this.paymentWebhookForm.value['version']
      );

      ApiKeysComponent.showToast(await firstValueFrom(this.translate.get('My settings saved successfully')));
    } catch (e) {
      console.log('Submit Form Error', e);
      if (e.error.title) {
        ApiKeysComponent.showToast(await firstValueFrom(this.translate.get(e.error.title)));
      } else {
        ApiKeysComponent.showToast(await firstValueFrom(this.translate.get('Could not save my setting. Try again')));
      }
    } finally {
      this.submitting = false;
    }
  }


  async testPartnerActivationWebhook() {
    let response = await this.api.testPartnerActivationWebhook(
      this.partnerActivationWebhookForm.value['webhookUrl'],
      this.partnerActivationWebhookForm.value['httpHeader1'],
      this.partnerActivationWebhookForm.value['httpHeader2'],
      this.partnerActivationWebhookForm.value['httpHeader3'],
      this.partnerActivationWebhookForm.value['httpHeader4'],
      this.partnerActivationWebhookForm.value['httpHeader5'],
      this.partnerActivationWebhookForm.value['httpHeader1Value'],
      this.partnerActivationWebhookForm.value['httpHeader2Value'],
      this.partnerActivationWebhookForm.value['httpHeader3Value'],
      this.partnerActivationWebhookForm.value['httpHeader4Value'],
      this.partnerActivationWebhookForm.value['httpHeader5Value'],
      this.partnerActivationWebhookForm.value['version']
    );
    console.log('response webhook', response.webhookResponse);
    alert(JSON.stringify(response.webhookResponse));
  }

  async testPaymentWebhook() {
    console.log('test payment webhook');
    try {
      let response = await this.api.testPaymentWebhook(
        this.paymentWebhookForm.value['webhookUrl'],
        this.paymentWebhookForm.value['httpHeader1'],
        this.paymentWebhookForm.value['httpHeader2'],
        this.paymentWebhookForm.value['httpHeader3'],
        this.paymentWebhookForm.value['httpHeader4'],
        this.paymentWebhookForm.value['httpHeader5'],
        this.paymentWebhookForm.value['httpHeader1Value'],
        this.paymentWebhookForm.value['httpHeader2Value'],
        this.paymentWebhookForm.value['httpHeader3Value'],
        this.paymentWebhookForm.value['httpHeader4Value'],
        this.paymentWebhookForm.value['httpHeader5Value'],
        this.paymentWebhookForm.value['version']
      );
      console.log('response', response);
      if (typeof response === 'string') {
        console.log('response is string');
        alert(response);
      } else {
        console.log('response webhook', response.webhookResponse);
        alert(JSON.stringify(response.webhookResponse));
      }
    } catch (e) {
      console.log('error', e);
      alert(e);
    }
  }

  async testSettlementWebhook() {
    let response = await this.api.testSettlementWebhook(
      this.settlementWebhookForm.value['webhookUrl'],
      this.settlementWebhookForm.value['httpHeader1'],
      this.settlementWebhookForm.value['httpHeader2'],
      this.settlementWebhookForm.value['httpHeader3'],
      this.settlementWebhookForm.value['httpHeader4'],
      this.settlementWebhookForm.value['httpHeader5'],
      this.settlementWebhookForm.value['httpHeader1Value'],
      this.settlementWebhookForm.value['httpHeader2Value'],
      this.settlementWebhookForm.value['httpHeader3Value'],
      this.settlementWebhookForm.value['httpHeader4Value'],
      this.settlementWebhookForm.value['httpHeader5Value'],
      this.settlementWebhookForm.value['version']
    );
    alert(JSON.stringify(response.webhookResponse));
  }

  private static showToast(msg) {
    Snackbar.show({
      text: msg,
      pos: 'bottom-center'
    });
  }

  installShopify() {
    let shopifyShop = this.form.value['shopifyShopDomain'];
    if (shopifyShop != null && shopifyShop.startsWith('https://')) {
      shopifyShop = shopifyShop.replace('https://', '');
    }
    let installUrl = this.env.getShopifyApp() + '/install?shop=' + shopifyShop;

    window.open(installUrl);
  }

  // noinspection DuplicatedCode
  private async loadResources() {
    await this.loader.loadExternalStyles('/plugins/notification/snackbar/snackbar.min.css');
    await this.loader.loadExternalScript('/plugins/notification/snackbar/snackbar.min.js');
    await this.loader.loadExternalStyles('/assets/css/users/account-setting.css');
    await this.loader.loadExternalScript('/assets/js/users/account-settings.js');
  }

  private fileToBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  }

  fileName: string;
  fileData: any;

  downloadFile(fileBody: any, fileName: string) {
    const a = document.createElement('a');
    const blob = new Blob([atob(fileBody)], {type: 'text/csv'});
    const url = window.URL.createObjectURL(blob);

    a.href = url;
    a.download = fileName + '.csv';
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }

  async downloadShopifyOrders() {
    this.downloadingShopify = true;
    const shopifyMatchingOrdersCsv = await this.api.downloadShopifyMatchingOrders(this.fileName, this.fileData);
    this.downloadingShopify = false;
    this.downloadFile(shopifyMatchingOrdersCsv.fileBody, shopifyMatchingOrdersCsv.fileName);
  }

  async onFileSelected(event: Event) {
    let fileTarget: any = event.target;
    const file: File = fileTarget.files[0];
    console.log('file', file);
    if (file) {
      this.fileName = file.name;
      this.fileToBase64(file).then(data => {
        console.log('data', data);
        this.fileData = data;
      });
    }
  }
}
